import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { ConceptTypeVolume } from "../../../../constants";

const { Option, OptGroup } = Select;

export const CombinedConceptSelector = ({
    size = "small",
    width = 180,
    sentimentDisabled,
    conceptTypeDay,
    conceptList,
    setConceptList,
    setSelectedLocalConcepts,
    conceptLists,
    handleChangeType,
    resetType,
    ...props
}) => {
    const [selectedValue, setSelectedValue] = useState(
        conceptList ? conceptList : `Type: ${conceptTypeDay}`
    );
    useEffect(() => {
        if (conceptList) {
            setSelectedValue(conceptList);
        } else if (conceptTypeDay) {
            setSelectedValue(`Type: ${conceptTypeDay}`);
        }
    }, [conceptList, conceptTypeDay]);
    const handleChange = (value) => {
        const isTypeOption = value.startsWith("Type: ");

        if (isTypeOption) {
            const typeValue = value.replace("Type: ", "");
            handleChangeType(typeValue);
            // setConceptList(null);
            setSelectedValue(`Type: ${typeValue}`);
        } else {
            setConceptList(value);
            setSelectedLocalConcepts([]);
            setSelectedValue(value);
            if (resetType) resetType(null);
        }
    };

    let conceptTypeOptions = Object.values(ConceptTypeVolume).map((type) => ({
        label: type.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
        value: `Type: ${type}`,
    }));

    if (sentimentDisabled) {
        conceptTypeOptions = conceptTypeOptions.filter(
            (option) => option.value !== "Type: sentiment_suggested"
        );
    }

    const conceptListOptions = conceptLists?.map((list) => ({
        label: list.name + ` (${list.concepts.length})`,
        value: list.concept_list_id,
    }));

    return (
        <Select
            {...props}
            showSearch
            data-testid="conceptList"
            style={{ width: width }}
            placeholder="Select a concept or list"
            value={selectedValue}
            size={size}
            onChange={handleChange}
        >
            <OptGroup label="Concept Types">
                {conceptTypeOptions.map((option) => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </OptGroup>
            <OptGroup label="Concept Lists">
                {conceptListOptions?.map((option) => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </OptGroup>
        </Select>
    );
};
